
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  components: {},
  props: {
    label: {
      type: String,
      required: false,
    },
  },
});
